import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LOCAL_AUTH_TOKEN_PATH, LocalAuthService } from './local-auth.service';

/**
 * Stands in for MsalInterceptor when environment.useMockAuth is true (see app.module.ts):
 * attaches the token minted by LocalAuthService instead of doing a real MSAL-acquired token.
 */
@Injectable()
export class LocalAuthInterceptor implements HttpInterceptor {
  constructor(private localAuthService: LocalAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiUrl) || req.url.endsWith(LOCAL_AUTH_TOKEN_PATH)) {
      return next.handle(req);
    }

    return from(this.localAuthService.getToken()).pipe(
      switchMap(token => next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })))
    );
  }
}
